<mat-toolbar class="subtitulo">Cotações Materiais</mat-toolbar>
<div class="painel-principal" style="padding: 10px;">
    <div class="painel-consultar">
        <form #formConsultar="ngForm">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill>

                <mat-form-field fxFlex="100%" fxFlexOffset="20px">
                    <mat-icon matPrefix>search</mat-icon>
                    <mat-label fxFlexOffset="20px">Selecione um material</mat-label>
                    <mat-select  [(ngModel)]="idMaterial" fxFlexOffset="20px"  name="materiais">
                        <mat-option></mat-option>
                        <mat-option *ngFor="let d of listaMateriais" [value]="d.id">
                            {{d.nome}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-hint *ngIf="listaMateriais?.length === 0" align="start" >Nenhum material cadastrado</mat-hint>
            </div>


            <div dir="rtl" class="botoes" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 20px;"
                fxFlexFill>

                <button mat-raised-button fxFlex="20%" (click)="consultar()">
                    CONSULTAR
                </button>

                <button mat-raised-button fxFlex="20%" style="padding-right: 20px" (click)="limpar()" route>
                    LIMPAR
                </button>

            </div>
        </form>

        <table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource" style="margin-top: 20px">


            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef> ID: </th>
                <td mat-cell *matCellDef="let element"> {{element.id}} </td>
            </ng-container>


            <ng-container matColumnDef="material">
                <th mat-header-cell *matHeaderCellDef> Material: </th>
                <td mat-cell *matCellDef="let element"> {{element.material.nome}} </td>
            </ng-container>

            <ng-container matColumnDef="dataCotacao">
                <th mat-header-cell *matHeaderCellDef> Data : </th>
                <td mat-cell *matCellDef="let element"> {{element.dataCotacao | dataSimples }} </td>
            </ng-container>
            <ng-container matColumnDef="dataValidadeCotacao">
                <th mat-header-cell *matHeaderCellDef> Data de Validade: </th>
                <td mat-cell *matCellDef="let element"> {{element.dataValidadeCotacao | dataSimples }} </td>
            </ng-container>
            <ng-container matColumnDef="valorTotalCotacao">
                <th mat-header-cell *matHeaderCellDef> Valor Total: </th>
                <td mat-cell *matCellDef="let element"> {{element.valorTotalCotacao | currency: 'BRL'}} </td>
            </ng-container>

            <ng-container matColumnDef="acoes">
                <th mat-header-cell *matHeaderCellDef> Ações </th>
                <td mat-cell *matCellDef="let element">
                    <button *ngIf="perfilAcesso.deleta"  mat-button (click)="deletar(element)">
                        <mat-icon>delete</mat-icon>
                    </button>
                    <button *ngIf="perfilAcesso.consulta" mat-button (click)="atualizar(element)">
                        <mat-icon>search</mat-icon>
                    </button>
                </td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <div [hidden]="!mostrarTabela">
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
        <ng-template #tabelaSemDados>
            <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 20px">
                {{msg}}
            </div>
        </ng-template>

        <div fxLayout="row" *ngIf="perfilAcesso.insere" fxLayoutAlign="end center" fxLayoutGap="16px"
            style="padding-top: 50px">
            <div>
                <button matTooltip="Adicionar nova cotação de material" mat-fab color="primary"
                    [routerLink]="['/cotacoesmateriais/cadastrar']" routerLinkActive="router-link-active">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>
